/**
 * Las fotos de Bokun (keyPhoto.originalUrl) son los archivos originales en S3:
 * algunas pesan 2–5 MB. Bokun las sirve redimensionadas en imgcdn.bokun.tools
 * (?w=ancho). Ej.: 4,8 MB → 124 KB a 800 px. Esto era lo que más frenaba la
 * portada en celular desde que los tours vienen en el HTML del SSR.
 */
const BOKUN_S3_RE = /^https?:\/\/bokun\.s3\.amazonaws\.com\/([^?#]+)/i;
const BOKUN_CDN_RE = /^https?:\/\/imgcdn\.bokun\.tools\/([^?#]+)/i;

function bokunFile(url: string | null | undefined): string | null {
    if (!url) return null;
    const m = url.trim().match(BOKUN_S3_RE) || url.trim().match(BOKUN_CDN_RE);
    return m ? m[1] : null;
}

/** URL redimensionada si es una foto de Bokun; si no, la devuelve igual. */
export function bokunImg(url: string | null | undefined, width: number): string {
    const file = bokunFile(url);
    return file ? `https://imgcdn.bokun.tools/${file}?w=${width}` : (url || '');
}

/** srcset con varios anchos (solo fotos de Bokun; null si no aplica). */
export function bokunSrcset(url: string | null | undefined, widths = [480, 800, 1200]): string | null {
    const file = bokunFile(url);
    return file ? widths.map(w => `https://imgcdn.bokun.tools/${file}?w=${w} ${w}w`).join(', ') : null;
}
